import heading from './heading';
import title from './title';

export default { ...heading, title };
